import { useContext, useEffect, useRef, useState } from "react";
import { ConfigContext } from "../../../Context/ConfigContext";
import { axiosGet } from "../../../Apis/axiosMethods";
import { FiChevronDown, FiChevronUp, FiCheck, FiFilter } from "react-icons/fi";
import "../CarBatteries/Batteries.css";
import { OverlayLoader } from "../../../Components/Shimmers";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import OEBrandsCarousol from "../PartsComponent/OEBrandsCarousol";
import { ImageWithFallback } from "../../../Components/GlobalFunctions";
import PartsHorizontalCard from "../../../Components/Cards/PartsHorizontalCard";
import { Helmet } from "react-helmet";
import slugify from "slugify";
import BatteriesPagination from "../../../Components/Table/BatteriesPagination";
import { default_image } from "../../../Imgaes";

const emptyFilters = {
    brands: [],
    capacity: [],
    viscosity: [],
    specification: [],
    manufacture_brands: [],
    product_names: [], // multi-select product names (ART_PRODUCT_NAME)
};

const OilLubes = () => {
    const {
        business_type,
        currency,
        apiURL,
        gdcURL,
        PCID
    } = useContext(ConfigContext);

    const [products, setProducts] = useState([]);

    const [showMore, setShowMore] = useState(false);
    const OEM_TEXT_LIMIT = 778;

    const [isUpdate, setIsUpdate] = useState(false);


    const { t } = useTranslation();
    const dir = localStorage.getItem("dir");
    const title = "Oils & Lubes";

    const str_id = 706233;
    const pt_id = 3;

    const [battery, setBattery] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiFilters, setApiFilters] = useState({
        brands: [],
        capacity: [],
        viscosity: [],
        specification: [],
        manufacture_brands: []
    });

    const [filtersLoading, setFiltersLoading] = useState(false);
    const [openAccordion, setOpenAccordion] = useState("Product");
    const [filters, setFilters] = useState(emptyFilters);
    const [tempFilters, setTempFilters] = useState(emptyFilters);

    const [searchParams, setSearchParams] = useSearchParams();

    const pageFromUrl = Number(searchParams.get("page")) || 1;
    const limitFromUrl = Number(searchParams.get("limit")) || 50;

    const [page, setPage] = useState(pageFromUrl);
    const [limit, setLimit] = useState(limitFromUrl);

    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isSticky, setSticky] = useState(false);

    const [afmBrands, setAfmBrands] = useState([]);
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [selectedBrandsArray, setSelectedBrandsArray] = useState([]);
    const [selectedBrandTags, setSelectedBrandTags] = useState([]);

    const [oeBrands, setOeBrands] = useState([]);
    const [selectedOEBrandsArray, setSelectedOEBrandsArray] = useState([]);

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 10,
            slidesToSlide: 3,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 4,
            slidesToSlide: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 3,
            slidesToSlide: 1,
        },
    };

    const getSelectedAFMBrands = (selectedArray) => {
        return (selectedArray || [])
            .map((item) => ({
                BRAND_NAME: item?.BRAND_NAME || item?.SUP_BRAND || "",
                SUP_ID: Number(item?.SUP_ID || 0),
            }))
            .filter((item) => item.BRAND_NAME && item.SUP_ID > 0);
    };

    const getSelectedOEBrands = (selectedArray) => {
        return (selectedArray || [])
            .map((item) => {
                if (typeof item === "string") return item;
                return (
                    item?.BRAND_NAME ||
                    item?.SUP_BRAND ||
                    item?.ART_BRAND_NAME ||
                    item?.brand_name ||
                    item?.name ||
                    ""
                );
            })
            .map((item) => item?.toString().trim())
            .filter(Boolean);
    };

    const fetchProducts = async () => {
        try {
            const response = await axiosGet("/Parts/GetDepartmentProductsName", { product_id: 3 });

            if (response?.data?.success) {
                setProducts(Array.isArray(response?.data?.data) ? response.data.data : []);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };

    const fetchBatteries = async (
        selectedFilters = filters,
        selectedPage = page,
        afmSelection = selectedBrandsArray,
        oeSelection = selectedOEBrandsArray,
        selectedLimit = limit
    ) => {
        try {
            setLoading(true);

            const params = {
                limit: selectedLimit,
                page: selectedPage,
                type: business_type,
                currency,
                str_id,
                pc_id: PCID
            };

            const sidebarAFMBrands = (selectedFilters?.brands || [])
                .filter((brand) => Number(brand?.SUP_ID) > 0)
                .map((brand) => ({
                    BRAND_NAME: brand?.BRAND_NAME || "",
                    SUP_ID: Number(brand?.SUP_ID),
                }));

            const sidebarOEBrands = (selectedFilters?.brands || [])
                .filter((brand) => Number(brand?.SUP_ID) === 0)
                .map((brand) => brand?.BRAND_NAME)
                .filter(Boolean);

            const carouselAFMBrands = getSelectedAFMBrands(afmSelection);
            const carouselOEBrands = getSelectedOEBrands(oeSelection);

            const finalAFMBrands =
                carouselAFMBrands.length > 0 ? carouselAFMBrands : sidebarAFMBrands;
            const finalOEBrands =
                carouselOEBrands.length > 0 ? carouselOEBrands : sidebarOEBrands;

            if (finalAFMBrands.length > 0) {
                params.selectedBrands = JSON.stringify(finalAFMBrands);
            }

            if (finalOEBrands.length > 0) {
                params.selectedOEBrands = JSON.stringify(finalOEBrands);
            }

            Object.entries(selectedFilters || {}).forEach(([key, values]) => {
                if (key === "brands") return;

                // Multi-select product names → send BOTH unique LAP_PT_IDs AND the names
                if (key === "product_names") {
                    const names = Array.isArray(values) ? values : [];
                    if (names.length === 0) return;

                    const ids = Array.from(
                        new Set(
                            names
                                .map((name) => {
                                    const product = (products || []).find(
                                        (p) => getProductName(p) === name
                                    );
                                    return product ? getProductId(product) : null;
                                })
                                .filter((id) => id !== null && id !== undefined && id !== "")
                        )
                    );

                    if (ids.length > 0) {
                        params.product_id = ids;
                    }
                    return;
                }

                if (Array.isArray(values) && values.length > 0) {
                    params[key] = values;
                }
            });

            const response = await axiosGet("/Parts/GetDepartmentPartsByOilAndLubes", params);

            if (response?.data?.success) {
                setBattery(Array.isArray(response?.data?.data) ? response.data.data : []);
                setTotalPages(Number(response?.data?.total_pages || 1));
                setTotalRecords(Number(response?.data?.total_records || 0));
                setPage(Number(response?.data?.page || selectedPage));
            } else {
                setBattery([]);
                setTotalPages(1);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error("Fetch oil and lubes error:", error);
            setBattery([]);
            setTotalPages(1);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };

    const fetchFilters = async () => {
        try {
            setFiltersLoading(true);

            const response = await axiosGet("/Parts/GetDepartmentsByOilAndLubesFilters", { pc_id: PCID });

            if (response?.data?.success) {
                const data = response?.data?.data || {};
                setApiFilters({
                    brands: Array.isArray(data?.brands) ? data.brands : [],
                    capacity: Array.isArray(data?.capacity) ? data.capacity : [],
                    viscosity: Array.isArray(data?.viscosity) ? data.viscosity : [],
                    specification: Array.isArray(data?.specification) ? data.specification : [],
                    manufacture_brands: Array.isArray(data?.manufacture_brands) ? data.manufacture_brands : [],
                });
            } else {
                setApiFilters({
                    brands: [],
                    capacity: [],
                    viscosity: [],
                    specification: [],
                    manufacture_brands: [],
                });
            }
        } catch (error) {
            console.error("Fetch oil and lubes filters error:", error);
            setApiFilters({
                brands: [],
                capacity: [],
                viscosity: [],
                specification: [],
                manufacture_brands: [],
            });
        } finally {
            setFiltersLoading(false);
        }
    };

    const fetchAfmBrands = async () => {
        try {
            const response = await axiosGet(`/Parts/GetDepartmentsBrandsCar`, {
                pc_id: localStorage.getItem("pc_id"),
                str_id: 706233,
                currency,
                limit,
                page: 1,
                brands: selectedBrands,
                type: "oil",
                pt_id,
            });

            setAfmBrands(response?.data?.success ? response?.data?.data || [] : []);
        } catch (error) {
            console.error("Error fetching AFM brands:", error);
            setAfmBrands([]);
        }
    };

    const fetchOeBrands = async () => {
        try {
            const pcId = localStorage.getItem("pc_id");
            const url = `/Parts/GetDepartmentsOEBrandsCar`;
            const params = { pt_id };
            if (pcId) params.pc_id = pcId;

            const response = await axiosGet(url, params);
            setOeBrands(response?.data?.success ? response?.data?.data || [] : []);
        } catch (error) {
            console.error("Error fetching OE brands:", error);
            setOeBrands([]);
        }
    };

    const handleLimitChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
        fetchBatteries(filters, 1, selectedBrandsArray, selectedOEBrandsArray, newLimit);
    };

    const isFirstRun = useRef(true);

    useEffect(() => {
        const initialFilters = { ...emptyFilters };
        setFilters(initialFilters);
        setTempFilters(initialFilters);
        setSelectedBrands([]);
        setSelectedBrandsArray([]);
        setSelectedBrandTags([]);
        setSelectedOEBrandsArray([]);

        if (isFirstRun.current) {
            isFirstRun.current = false;
            const initialPage = pageFromUrl > 0 ? pageFromUrl : 1;
            setPage(initialPage);
            fetchBatteries(initialFilters, initialPage, [], []);
        } else {
            setPage(1);
            fetchBatteries(initialFilters, 1, [], []);
        }

        fetchFilters();
        fetchAfmBrands();
        fetchOeBrands();
        fetchProducts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [business_type, currency]);

    useEffect(() => {
        setSearchParams((previousParams) => {
            const params = new URLSearchParams(previousParams);

            params.set("page", page);
            params.set("limit", limit);

            return params;
        }, { replace: true });
    }, [page, limit]);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 200) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const filterOptions = [
        { key: "capacity", title: "Capacity" },
        { key: "viscosity", title: "Viscosity" },
        { key: "specification", title: "Specification" },
        { key: "manufacture_brands", title: "Manufacture Brands" },
    ];

    const getApiFilterValue = (item) => {
        if (item === null || item === undefined) return "";
        if (typeof item === "object") {
            return item?.value?.toString()?.trim() || "";
        }
        return item?.toString()?.trim();
    };

    const getFilterOptions = (key) => {
        const values = apiFilters?.[key] || [];
        return [...new Set(values.map(getApiFilterValue).filter(Boolean))];
    };

    const getProductName = (product) => {
        if (product === null || product === undefined) return "";
        if (typeof product === "string") return product.trim();
        return (
            product?.ART_PRODUCT_NAME ||
            product?.PRODUCT_NAME ||
            product?.PRODUCT_DESC ||
            ""
        ).toString().trim();
    };

    const getProductId = (product) => {
        if (product === null || product === undefined) return null;
        if (typeof product !== "object") return null;
        const raw = product?.LAP_PT_ID ?? product?.PT_ID ?? product?.PRODUCT_ID;
        if (raw === null || raw === undefined || raw === "") return null;
        return Number(raw);
    };

    const toggleFilter = (key, value) => {
        setTempFilters((prev) => {
            const currentValues = prev?.[key] || [];
            const isSelected = currentValues.includes(value);

            return {
                ...prev,
                [key]: isSelected
                    ? currentValues.filter((item) => item !== value)
                    : [...currentValues, value],
            };
        });
    };

    const toggleAccordion = (title) => {
        setOpenAccordion((prev) => (prev === title ? "" : title));
    };

    const applyFilters = () => {
        const selectedFilters = { ...tempFilters };

        const selectedAFM =
            selectedFilters?.brands?.filter((item) => Number(item?.SUP_ID) > 0) || [];
        const selectedOE =
            selectedFilters?.brands?.filter((item) => Number(item?.SUP_ID) === 0) || [];

        setFilters(selectedFilters);
        setSelectedBrands(selectedAFM);
        setSelectedBrandsArray(selectedAFM);
        setSelectedOEBrandsArray(getSelectedOEBrands(selectedOE));
        setSelectedBrandTags(selectedFilters?.brands || []);
        setPage(1);

        fetchBatteries(selectedFilters, 1, selectedAFM, selectedOE);
    };

    const clearFilters = () => {
        setFilters(emptyFilters);
        setTempFilters(emptyFilters);
        setSelectedBrands([]);
        setSelectedBrandsArray([]);
        setSelectedBrandTags([]);
        setSelectedOEBrandsArray([]);
        setPage(1);

        fetchBatteries(emptyFilters, 1, [], []);
    };

    const toggleAfmBrand = (brand) => {
        const supId = Number(brand?.sup_id || brand?.SUP_ID || 0);
        const brandName = (brand?.sup_brand || brand?.BRAND_NAME || "").toString().trim();

        if (!supId || !brandName) return;

        const alreadySelected = selectedBrandsArray.some(
            (item) => Number(item?.SUP_ID) === supId
        );

        const newSelectedBrands = alreadySelected
            ? selectedBrandsArray.filter((item) => Number(item?.SUP_ID) !== supId)
            : [...selectedBrandsArray, { BRAND_NAME: brandName, SUP_ID: supId }];

        const newFilters = { ...filters, brands: newSelectedBrands };

        setSelectedBrands(newSelectedBrands);
        setSelectedBrandsArray(newSelectedBrands);
        setSelectedOEBrandsArray([]);
        setSelectedBrandTags(newSelectedBrands);
        setFilters(newFilters);
        setTempFilters((prev) => ({ ...prev, brands: newSelectedBrands }));
        setPage(1);

        fetchBatteries(newFilters, 1, newSelectedBrands, []);
        window.scrollTo(0, 0);
    };

    const handleOEBrandsChange = (value) => {
        const newBrands = getSelectedOEBrands(value);

        setSelectedOEBrandsArray(newBrands);
        setSelectedBrands([]);
        setSelectedBrandsArray([]);

        const newOEBrands = newBrands.map((brandName) => ({
            BRAND_NAME: brandName,
            SUP_ID: 0,
        }));

        setSelectedBrandTags(newOEBrands);

        const newFilters = { ...filters, brands: newOEBrands };

        setFilters(newFilters);
        setTempFilters((prev) => ({ ...prev, brands: newOEBrands }));
        setPage(1);
        fetchBatteries(newFilters, 1, [], newBrands);
        window.scrollTo(0, 0);
    };

    const removeBrandTag = (brand) => {
        const supId = Number(brand?.SUP_ID || 0);
        const brandName = (
            brand?.BRAND_NAME ||
            brand?.SUP_BRAND ||
            brand?.ART_BRAND_NAME ||
            ""
        )
            .toString()
            .trim();

        if (supId > 0) {
            toggleAfmBrand({ sup_id: supId, sup_brand: brandName });
            return;
        }

        const currentOE = selectedOEBrandsArray || [];

        const newOE = currentOE.filter((item) => {
            const itemName = (
                typeof item === "string"
                    ? item
                    : item?.BRAND_NAME ||
                    item?.SUP_BRAND ||
                    item?.ART_BRAND_NAME ||
                    item?.brand_name ||
                    item?.name ||
                    ""
            )
                .toString()
                .trim()
                .toLowerCase();

            return itemName !== brandName.toLowerCase();
        });

        handleOEBrandsChange(newOE);
    };

    const BrandsTags = () => {
        if (!selectedBrandTags?.length) return null;

        return (
            <div className="mb-3">
                <h6 className="mt-2 mb-2">{t("selected_filters")}</h6>

                {selectedBrandTags
                    .filter(
                        (item) =>
                            typeof item === "string" || Number(item?.SUP_ID || 0) > 0
                    )
                    .map((item, index) => {
                        const brandName =
                            typeof item === "string"
                                ? item
                                : item?.BRAND_NAME ||
                                item?.SUP_BRAND ||
                                item?.ART_BRAND_NAME ||
                                "";

                        return (
                            <span
                                key={`selected-brand-${brandName}-${index}`}
                                onClick={() =>
                                    removeBrandTag(
                                        typeof item === "string"
                                            ? { BRAND_NAME: item, SUP_ID: 0 }
                                            : item
                                    )
                                }
                                className="badge badge-pill mr-4 pt-2 pb-2"
                                style={{ backgroundColor: "#e9e9e9", cursor: "pointer" }}
                            >
                                {brandName}{" "}
                                <i
                                    className="fas fa-times-circle lightColorText"
                                    style={{ cursor: "pointer" }}
                                />
                            </span>
                        );
                    })}
            </div>
        );
    };

    const ButtonGroup = ({ next, previous, ...rest }) => {
        const { carouselState: { currentSlide }, } = rest;

        return (
            <div className="carousel-button-group">
                <button
                    type="button"
                    style={{
                        padding: "2px 6px",
                        position: "absolute",
                        left: 0,
                        top: "8px",
                        marginLeft: "-40px",
                    }}
                    className={`btn btn-outline-dark btn-sm ${currentSlide === 0 ? "disable" : ""
                        }`}
                    onClick={() => previous()}
                >
                    <i className="fas fa-chevron-left" />
                </button>

                <button
                    type="button"
                    style={{
                        padding: "2px 6px",
                        position: "absolute",
                        right: 0,
                        top: "8px",
                        marginRight: "-30px",
                    }}
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => next()}
                >
                    <i className="fas fa-chevron-right" />
                </button>
            </div>
        );
    };

    const BrandsOptions = () => {
        if (!afmBrands?.length) return null;

        const sortedBrands = [...afmBrands].sort((a, b) =>
            Number(selectedBrandsArray.some((item) => Number(item?.SUP_ID) === Number(b?.sup_id))) -
            Number(selectedBrandsArray.some((item) => Number(item?.SUP_ID) === Number(a?.sup_id)))
        );

        return (
            <div
                style={{ position: "relative" }}
                className={`prevent-select ${selectedBrandTags?.length ? "mt-2" : ""}`}
            >
                <Carousel
                    arrows={false}
                    renderButtonGroupOutside={afmBrands.length > 10}
                    customButtonGroup={<ButtonGroup />}
                    responsive={responsive}
                    swipeable
                    draggable
                    showDots={false}
                    infinite={false}
                    autoPlaySpeed={1000}
                    keyBoardControl
                    customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                >
                    {sortedBrands.map((brand, index) => {
                        const supId = Number(brand?.sup_id || brand?.SUP_ID || 0);
                        const brandName = (brand?.sup_brand || brand?.BRAND_NAME || "")
                            .toString()
                            .trim();
                        const selected = selectedBrandsArray.some(
                            (item) => Number(item?.SUP_ID) === supId
                        );

                        return (
                            <div
                                key={`afm-brand-${supId}-${index}`}
                                onClick={() => toggleAfmBrand(brand)}
                                style={{
                                    cursor: "pointer",
                                    height: "40px",
                                    width: "80px",
                                    textAlign: "center",
                                    border: selected ? "2px solid #cc000b" : "0px solid #ccc",
                                }}
                            >
                                <ImageWithFallback
                                    src={`${brand?.logo_url}`}
                                    alt={brandName}
                                    index={index}
                                    fallbackText={brandName}
                                />
                            </div>
                        );
                    })}
                </Carousel>
            </div>
        );
    };

    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > totalPages || newPage === page) return;

        setPage(newPage);
        fetchBatteries(filters, newPage, selectedBrandsArray, selectedOEBrandsArray);

        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const renderFiltersSidebar = () => (
        <div className="mt-2 border p-4">
            <h5 className="d-flex align-items-center mb-3">
                <FiFilter className="mr-2" /> Filters
            </h5>

            {products && products.length > 0 && (
                <FilterAccordion
                    title="Product"
                    openAccordion={openAccordion}
                    toggleAccordion={toggleAccordion}
                >
                    {products.map((product, idx) => {
                        const productName = getProductName(product);
                        const productId = getProductId(product);

                        if (!productName || productId === null) return null;

                        const isSelected = (tempFilters.product_names || []).includes(productName);

                        return (
                            <FilterOption
                                key={`product-${productId}-${idx}-${productName}`}
                                label={productName}
                                checked={isSelected}
                                onChange={() => toggleFilter("product_names", productName)}
                            />
                        );
                    })}
                </FilterAccordion>
            )}

            {apiFilters.brands && apiFilters.brands.length > 0 && (
                <FilterAccordion
                    title="Brand"
                    openAccordion={openAccordion}
                    toggleAccordion={toggleAccordion}
                >
                    {apiFilters.brands.map((brand, idx) => {
                        const brandName = (
                            brand?.SUP_BRAND ||
                            brand?.BRAND_NAME ||
                            brand?.brand ||
                            ""
                        )
                            .toString()
                            .trim();
                        const supId = Number(brand?.SUP_ID || brand?.sup_id || 0);
                        const isChecked = (tempFilters.brands || []).some(
                            (b) =>
                                Number(b?.SUP_ID) === supId && b?.BRAND_NAME === brandName
                        );

                        return (
                            <FilterOption
                                key={`brand-${supId}-${idx}`}
                                label={brandName}
                                checked={isChecked}
                                onChange={() => {
                                    setTempFilters((prev) => {
                                        const current = prev.brands || [];
                                        const exists = current.some(
                                            (b) =>
                                                Number(b?.SUP_ID) === supId &&
                                                b?.BRAND_NAME === brandName
                                        );
                                        const next = exists
                                            ? current.filter(
                                                (b) =>
                                                    !(
                                                        Number(b?.SUP_ID) === supId &&
                                                        b?.BRAND_NAME === brandName
                                                    )
                                            )
                                            : [...current, { BRAND_NAME: brandName, SUP_ID: supId }];
                                        return { ...prev, brands: next };
                                    });
                                }}
                            />
                        );
                    })}
                </FilterAccordion>
            )}

            {filterOptions.map((opt) => {
                const values = getFilterOptions(opt.key);
                if (!values || values.length === 0) return null;

                return (
                    <FilterAccordion
                        key={opt.key}
                        title={opt.title}
                        openAccordion={openAccordion}
                        toggleAccordion={toggleAccordion}
                    >
                        {values.map((val) => (
                            <FilterOption
                                key={`${opt.key}-${val}`}
                                label={val}
                                checked={(tempFilters[opt.key] || []).includes(val)}
                                onChange={() => toggleFilter(opt.key, val)}
                            />
                        ))}
                    </FilterAccordion>
                );
            })}

            <div className="mt-3">
                <button
                    className="btn btn-primary btn-block"
                    onClick={applyFilters}
                    disabled={filtersLoading}
                >
                    Apply Filters
                </button>
                <button
                    className="btn btn-outline-secondary btn-block mt-2"
                    onClick={clearFilters}
                    disabled={filtersLoading}
                >
                    Clear Filters
                </button>
            </div>
        </div>
    );

    return (
        <>
            {loading ? (
                <div style={{ height: "100vh" }}>
                    <OverlayLoader />
                </div>
            ) : (
                <div
                    className="header-bottom d-none d-lg-block"
                    style={{
                        borderBottom: "1px solid rgb(226, 226, 226)",
                        marginBottom: "10px",
                    }}
                >
                    <Helmet>
                        <title>{title}</title>
                    </Helmet>

                    <div className="container">
                        <nav
                            className="main-nav w-100"
                            style={{ textAlign: dir === "rtl" ? "right" : "left" }}
                        >
                            <div className="row justify-content-center">
                                <div className="col-md-3">
                                    {/* <UniCarSearch
                                        redirectURL={`/Spare-Parts/OilsLubes`}
                                    /> */}
                                    {renderFiltersSidebar()}
                                </div>

                                <div className="col-md-9">
                                    <h2
                                        className="mt-2"
                                        style={{
                                            color: "#132530",
                                            fontFamily: "Montserrat, Arial, sans-serif",
                                            fontSize: "22px",
                                            fontWeight: "500",
                                            lineHeight: "24px",
                                        }}
                                    >
                                        {title}
                                    </h2>

                                    <div style={isSticky ? {
                                        position: 'fixed',
                                        top: '0',
                                        backgroundColor: '#FFF',
                                        width: '100%',
                                        left: '0',
                                        padding: '10px 50px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        zIndex: 10000000
                                    } : {}}>
                                        {isSticky ? (
                                            <div className="row">
                                                <div className="col-4" style={{
                                                    color: '#59666e',
                                                    fontFamily: 'Montserrat, Arial, sans-serif',
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    lineHeight: '2',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    paddingRight: '3%'
                                                }}>
                                                </div>

                                                <div className="col-8">
                                                    <div className="mb-2">
                                                        {afmBrands.length > 0 && <BrandsOptions />}
                                                    </div>

                                                    <OEBrandsCarousol
                                                        brandsData={oeBrands}
                                                        setSelectedOEBrandsArray={setSelectedOEBrandsArray}
                                                        selectedOEBrandsArray={selectedOEBrandsArray}
                                                        setPage={setPage}
                                                        setAFMSelectedBrands={setSelectedBrands}
                                                        setSelectedBrandsArray={setSelectedBrandsArray}
                                                        isSticky={isSticky}
                                                        setSelectedBrandTags={setSelectedBrandTags}
                                                        onChange={handleOEBrandsChange}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className={dir === "rtl" ? "pr-5" : "pl-5"}>
                                                {afmBrands.length > 0 && (
                                                    <h5 className="text-muted mt-3">Aftermarket Brands</h5>
                                                )}

                                                {afmBrands.length > 0 && <BrandsTags />}
                                                {afmBrands.length > 0 && <BrandsOptions />}

                                                <div className="mt-2">
                                                    <OEBrandsCarousol
                                                        brandsData={oeBrands}
                                                        setSelectedOEBrandsArray={setSelectedOEBrandsArray}
                                                        selectedOEBrandsArray={selectedOEBrandsArray}
                                                        setPage={setPage}
                                                        setAFMSelectedBrands={setSelectedBrands}
                                                        setSelectedBrandsArray={setSelectedBrandsArray}
                                                        isSticky={isSticky}
                                                        setSelectedBrandTags={setSelectedBrandTags}
                                                        onChange={handleOEBrandsChange}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="row">
                                        <div className="container pt-5">
                                            {battery.length > 0 &&
                                                t("total_items", {
                                                    total: totalRecords ? totalRecords : 0,
                                                })}
                                        </div>

                                        <div className="row pb-4">
                                            {battery.length > 0 ? (
                                                battery.map((part, index) => {
                                                    const productSlug = slugify(
                                                        (
                                                            part?.PRODUCT_GROUP ||
                                                            part?.ART_PRODUCT_NAME ||
                                                            "-"
                                                        )
                                                            .replace(/,/g, "")
                                                            .toLowerCase()
                                                    );

                                                    const OE_part_slug =
                                                        slugify(`${productSlug}`.toLowerCase()) +
                                                        "-" +
                                                        slugify(
                                                            `${part.ART_SEARCH_NUMBER}`.toLowerCase()
                                                        ) +
                                                        `/${part?.ART_SUP_BRAND}`;

                                                    const part_slug = `${productSlug}-${part.ART_SEARCH_NUMBER}-${part?.ART_SUP_ID}`;

                                                    const partImg = part.MEDIA_SOURCE
                                                        ? `${part.MEDIA_SOURCE}`
                                                        : default_image;

                                                    return (
                                                        <div key={`r-part-id-${part.ART_ID}-${index}`}>
                                                            <PartsHorizontalCard
                                                                partImg={partImg}
                                                                criteria={part.ARTICLE_CRITERIA_JSON}
                                                                url={
                                                                    part.ART_TYPE === "OENumber"
                                                                        ? `/OE-Spare-Parts/Details/${OE_part_slug}`
                                                                        : `/Spare-Parts/Details/${part_slug}`
                                                                }
                                                                id={part.ART_ID}
                                                                title={
                                                                    part.PRODUCT_GROUP ??
                                                                    part?.ART_PRODUCT_NAME
                                                                }
                                                                number={part.ART_ARTICLE_NR}
                                                                price={
                                                                    business_type === 1
                                                                        ? Number(
                                                                            part?.VD_BG_PRICE ?? 0
                                                                        ).toFixed(2)
                                                                        : Number(
                                                                            part?.VD_BB_PRICE ?? 0
                                                                        ).toFixed(2)
                                                                }
                                                                display_price={part.display_price ?? 0}
                                                                mrp={
                                                                    `${part.VD_PRICE_MRP}` ??
                                                                    `${part?.stock_price_mrp}` ??
                                                                    0
                                                                }
                                                                display_price_mrp={
                                                                    part.display_price_mrp ?? 0
                                                                }
                                                                qty={part.VD_QTY}
                                                                imgUrl={partImg}
                                                                action={true}
                                                                brand={part.stock_brand_name}
                                                                suplogo={part.SUP_LOGO_NAME}
                                                                supid={part.SUP_ID}
                                                                redLabel={`Aftermarket`}
                                                                partInfo={part.ART_INFO}
                                                                pt_intl={part.PT_INTL}
                                                                art_type={part.ART_TYPE}
                                                                mfa_id={part.E_MFA_ID}
                                                                part={part}
                                                                SUP_WARRANTY={part?.SUP_WARRANTY}
                                                                stock_delivery_days={
                                                                    part?.stock_delivery_days
                                                                }
                                                            />
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div
                                                    className="col-sm-12 col-6 d-flex justify-content-center align-items-center"
                                                    style={{ marginLeft: "100px" }}
                                                >
                                                    <div className="card out-of-stock-card">
                                                        <div className="out-of-stock-icon">
                                                            <i className="fas fa-exclamation-circle"></i>
                                                        </div>

                                                        <div className="out-of-stock-title">
                                                            Temporarily Out of Stock
                                                        </div>

                                                        <div className="out-of-stock-text">
                                                            This part is currently unavailable and will be
                                                            restocked soon. Our team is updating
                                                            inventory to make it available shortly.
                                                            <br />
                                                            <br />
                                                            Thank you for your patience. Please check back
                                                            again soon for updates.
                                                        </div>
                                                    </div>

                                                    <style>
                                                        {`
                              .out-of-stock-card {
                                border: 1px solid #e0e0e0;
                                border-left: 6px solid #ff4b4b;
                                border-radius: 12px;
                                padding: 35px 30px;
                                background: #ffffff;
                                box-shadow: 0px 4px 14px rgba(0,0,0,0.07);
                                text-align: center;
                                max-width: 650px;
                                margin: 50px auto;
                                font-family: 'Montserrat', Arial, sans-serif;
                              }
                              .out-of-stock-icon {
                                font-size: 50px;
                                color: #ff4b4b;
                                margin-bottom: 15px;
                              }
                              .out-of-stock-title {
                                font-size: 22px;
                                font-weight: 600;
                                color: #0d1f2a;
                                margin-bottom: 12px;
                              }
                              .out-of-stock-text {
                                font-size: 15px;
                                color: #4a5a67;
                                line-height: 1.7;
                                max-width: 500px;
                                margin: 0 auto;
                              }
                            `}
                                                    </style>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <BatteriesPagination
                                        page={page}
                                        totalPages={totalPages}
                                        totalRecords={totalRecords}
                                        limit={limit}
                                        onPageChange={handlePageChange}
                                        onLimitChange={handleLimitChange}
                                    />

                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            )}
        </>
    );
};

const FilterAccordion = ({ title, openAccordion, toggleAccordion, children }) => {
    const isOpen = openAccordion === title;

    return (
        <div className="filter-accordion">
            <div
                className="filter-accordion-header"
                onClick={() => toggleAccordion(title)}
            >
                <span>{title}</span>
                {isOpen ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
            </div>

            {isOpen && <div className="filter-accordion-body">{children}</div>}
        </div>
    );
};

const FilterOption = ({ label, checked, onChange }) => (
    <label className="filter-option">
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span title={label}>{label}</span>
        {checked && <FiCheck size={12} className="filter-option-check" />}
    </label>
);

export default OilLubes;